import TabManage from "./TabManage";
import { Permission } from "~/hooks/permissions";
import TabsPage from "~/components/layout/TabsPage";
import TabImport from "./TabImport";

const UsersPage = () => {
  return <TabsPage basePath="users" tabs={{
    'manage': {
      label: 'Manage',
      permission: Permission.manageUsers,
      component: (id) => <TabManage id={id} />
    },
    'import': {
      label: 'Import',
      permission: Permission.importUsers,
      component: () => <TabImport />
    },
  }}/>
}

export default UsersPage;
